<template>
  <transition name="component-fade" mode="out-in">
    <Spinner class="mt-4" key="1" v-if="loading"></Spinner>
    <div v-else key="2">
      <div>
        <div class="d-flex mb-3">
          <h5 class="fw-bold">{{ post.community_topic.title }}</h5>
          <div class="ms-auto d-flex">

            <div class="dropdown ms-3 d-lg-none">
              <button class="btn btn-outline-dark btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fas fa-sliders-h"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-for="communityTopic in communityTopics" :key="communityTopic.id + communityTopic.title">
                  <a class="dropdown-item small fw-semibold" :href="communityTopic.url">{{ communityTopic.title }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="post card mb-3">
        <div class="card-body p-4 p-lg-5">
          <div class="d-flex">
            <div>
              <div class="mb-2">
                <small class="">{{ creator }}</small>
                >
                <small class="">
                  <a class="text-dark" :href="topicLink">
                    {{ post.community_topic.title }}
                  </a>
                </small>
                <small class="text-muted">{{ time(post.created_at) }}</small>
              </div>
              <div v-if="post.title">
                <h4 class="fw-bold">{{ post.title }}</h4>
              </div>
            </div>
            <div class="ms-auto" v-if="isPostAuthor">
              <div class="dropdown">
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  id="dropdownMenuButton"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-toggle="dropdown"
                >
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#" @click.prevent="showPostEditModal">
                    {{ 'Edit' | translate }}
                  </a>
                  <hr class="dropdown-divider" />
                  <a class="dropdown-item" href="#" @click.prevent="showDeleteModal(post.id)">
                    {{ 'Delete' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-if="post.student_id" style="white-space: pre-wrap">{{ post.body }}</div>
          <div v-else style="white-space: pre-wrap" v-html="markdown(post.body)"></div>

          <div class="mt-2" v-if="post.image">
            <img :src="imgUrl" class="img-fluid" />
          </div>
          <div class="mt-3" v-else-if="post.bunny_id && post.bunny_status === 3">
            <div class="ratio ratio-16x9">
              <iframe
                :src="`https://player.mediadelivery.net/embed/25534/${post.bunny_id}?autoplay=false&preload=false`"
                loading="lazy"
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                allowfullscreen="true"
              ></iframe>
            </div>
          </div>
          <div class="mt-2" v-else-if="post.video">
            <div class="ratio ratio-16x9">
              <iframe class="embed-responsive-item" :src="post.video"></iframe>
            </div>
          </div>
          <div class="mt-2 d-flex">
            <Votes :votable="post"></Votes>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <Comments :commentable="post"></Comments>
      </div>
      <PostEdit ref="postEditModal" :post="post" @postEdited="postEdited" />
      <ConfirmActionModal ref="ConfirmAction"></ConfirmActionModal>
    </div>
  </transition>
</template>

<script>
import snarkdown from 'snarkdown'
import xss from 'xss'
import Votes from '~/player/components/Votes'
import Comments from '~/player/components/Comments'
import Spinner from '~/app2/components/Spinner'
import PostEdit from '~/app2/components/community/PostEditWeb'
import ConfirmActionModal from '~/app2/components/ConfirmActionModal'

export default {
  components: {
    Votes,
    Comments,
    Spinner,
    PostEdit,
    ConfirmActionModal,
  },
  props: ['id', 'communityTopics'],
  data() {
    return {
      loading: true,
      post: null,
    }
  },
  mounted() {
    this.getPost()
  },
  computed: {
    isPostAuthor() {
      return this.post.student_id === this.$store.state.user.id && this.$store.state.user.type !== 'App\\User'
    },
    imgUrl() {
      return `https://djceg34j53tq.cloudfront.net/${this.post.image}`
    },
    creator() {
      return _.get(this.post, 'student.name', this.pageName)
    },
    pageName() {
      return _.get(this, '$store.state.page.name')
    },
    topicLink() {
      return `${window.location.protocol}//${window.location.host}/community/topics/${this.post.community_topic.id}`
    },
    post_id() {
      return this.$route.params.post
    },
  },
  methods: {
    markdown(text) {
      if (text) {
        return xss(snarkdown(text))
      }
      return ''
    },

    postEdited(data) {
      this.post = { ...this.post, ...data }
    },
    removePost(id) {
      axios.delete(`/json/community/posts/${id}`).then(() => {
        window.location.href = this.topicLink
        // this.$router.push({name: 'community'})
      })
    },
    showDeleteModal(id) {
      this.$refs.ConfirmAction.modal({
        action: this.removePost,
        payload: id,
      })
    },
    showPostEditModal() {
      this.$refs.postEditModal.show()
    },
    time(date) {
      const formatter = new Intl.RelativeTimeFormat(this.$i18n.locale(), {
        numeric: 'auto',
      })

      const DIVISIONS = [
        { amount: 60, name: 'seconds' },
        { amount: 60, name: 'minutes' },
        { amount: 24, name: 'hours' },
        { amount: 7, name: 'days' },
        { amount: 4.34524, name: 'weeks' },
        { amount: 12, name: 'months' },
        { amount: Number.POSITIVE_INFINITY, name: 'years' },
      ]

      function formatTimeAgo(date) {
        let duration = (new Date(date) - new Date()) / 1000

        for (let i = 0; i <= DIVISIONS.length; i++) {
          const division = DIVISIONS[i]
          if (Math.abs(duration) < division.amount) {
            return formatter.format(Math.round(duration), division.name)
          }
          duration /= division.amount
        }
      }

      return formatTimeAgo(date)
    },
    getPost() {
      return axios.post(`/json/community/posts/${this.id}`).then(({ data }) => {
        this.post = data
        this.loading = false
      })
    },
  },
}
</script>

<style></style>
